import React, { useState } from 'react';
import Select from "../../Component/Select";
import logo from "../../assets/logos/nexusforgelogo.png"

const NexusForge = () => {
    // State to handle form input values
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        amount:'',
        currencyAmount:"",
    });


    // State for form submission status
    const [isSubmitted, setIsSubmitted] = useState(false);

    // Handle input changes and update form data
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const selectData = [
        {
            id:1,
            name:"200",
            value: 200
    },
        {
            id:2,
            name:"300",
            value: 300
        },
        {
            id:3,
            name:"4000",
            value:4000
        },
    ]

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault(); // Prevent page reload
        console.log('Form submitted:', formData);

        // Simulate form submission process (e.g., API call)
        setTimeout(() => {
            setIsSubmitted(true); // Update state to show submission status
        }, 500);
    };

    return (
        <div className="w-2/4 bg-white  border-4 rounded-lg shadow relative  m-auto">

            <div className="flex items-center justify-center">
                <img className='w-44' src={logo}  alt={logo}/>
            </div>

                <form className="p-6 space-y-6">
                    <div className="grid grid-cols-6 gap-6">
                        <div className="col-span-6 sm:col-span-3">
                            <label htmlFor="product-name" className="text-md font-medium text-gray-900 block mb-2">Name</label>
                            <input
                                type="text"
                                name="name"
                                id="name"
                                value={formData.name} // Controlled input value
                                onChange={handleChange} // Update state on change
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="Full Name"
                                required
                            />
                        </div>
                        <div className="col-span-6 sm:col-span-3">
                            <label htmlFor="category" className="text-md font-medium text-gray-900 block mb-2">Email</label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                value={formData.email} // Controlled input value
                                onChange={handleChange} // Update state on change
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="Your Email Address"
                                required
                            />                        </div>
                        <div className="col-span-6 sm:col-span-3">
                            <label htmlFor="brand" className="text-md font-medium text-gray-900 block mb-2">Phone Number</label>
                            <input
                                type="tel"
                                name="phoneNumber"
                                id="phoneNumber"
                                value={formData.phoneNumber} // Controlled input value
                                onChange={handleChange} // Update state on change
                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-cyan-600 focus:border-cyan-600 block w-full p-3"
                                placeholder="Phone Number"
                                required
                            />
                        </div>
                        <div className="col-span-6 sm:col-span-3">
                            <label htmlFor="price" className="text-md font-medium text-gray-900 block mb-2">Amount</label>
                            <Select selctValue={formData?.amount}
                                    setSelectValue={(name, value) => setFormData({ ...formData, [name]: value })}
                                    name="amount"
                                    data={selectData}/>
                        </div>

                    </div>
                </form>

            <div className="flex items-center justify-center p-3 border-t border-gray-200 rounded-b">
                <button className="text-white bg-cyan-600 hover:bg-cyan-700 focus:ring-4 focus:ring-cyan-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center" onClick={handleSubmit}>Submit</button>
            </div>

        </div>
    );
};

export default NexusForge;
